import React from "react";
import { Arrows } from "./Extras.jsx";

export default props => {
  return (
    <div>
      <section className="section-heading row">FINALIZE</section>
      <section className="row finalize">
        <div className="col-sm-3">
          <span className="go-back" onClick={props.customize}>
            <Arrows focus className="rotateHoriz" /> Go Back{" "}
          </span>
          <h2>SUMMARY</h2>
          <a
            className="button button-focus"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#333333",
              color: "white"
            }}
            download="preview.png"
            href={props.fullImage}
          >
            DOWNLOAD DESIGN <Arrows focus />
          </a>
          <button
            onClick={props.submitBottle}
            className="button-focus"
            style={{ marginTop: "20px" }}
          >
            SUBMIT DESIGN <Arrows />
          </button>
        </div>
        <div className="col-sm-offset-1 finalizeBottle col-sm-4">
          <img
            alt="bottleImage"
            style={{ position: "absolute", left: "15px", height: "650px" }}
            src={props.fullImage}
          />
        </div>
      </section>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/Finalize.jsx